import { request } from "../../utils/request";

const getScreenData = (params) => {
  return request({
    url: "/common/screening/",
    method: "get",
    params,
  });
};

const saveScreeningFeedback = (data) => {
  return request({
    url: "/common/screening/",
    method: "put",
    data,
  });
};

export { getScreenData, saveScreeningFeedback };
